import {
	get,
	post
} from './http'

export default {
	// 获取航班列表 {"flightType":1,"psgType":1,"depCityPortCode":"CAN","arrCityPortCode":"PEK","depDate":"2020-06-28","cabinRank":3}
	getFlightList(flightType, cabinRank, psgType, depCityPortCode, arrCityPortCode, depDate, airLineCode) {
		return post('FlightOrder/getFlightsList', {
			flightType: flightType,
			cabinRank: cabinRank,
			psgType: psgType,
			depCityPortCode: depCityPortCode,
			arrCityPortCode: arrCityPortCode,
			depDate: depDate,
			airLineCode: airLineCode
		});
	},
	// 获取客规信息
	getStipulates(flightProductType, flightType, cabinCode, psgType, depCityPortCode, arrCityPortCode, depDate, flightNo) {
		return post('FlightOrder/getStipulates', {
			flightProductType: flightProductType,
			flightType: flightType,
			cabinCode: cabinCode,
			psgType: psgType,
			depCityPortCode: depCityPortCode,
			arrCityPortCode: arrCityPortCode,
			depDate: depDate,
			flightNo: flightNo
		});
	},
	getCityData() {
		return get(`FlightOrder/getCityData`, {});
	},
	createFlightOrder(OpenId, contactName, contactPhone, contactEmail, contactQQ, remark, flightType, cabinRank, psgType,
		passengerList, flightList, policyList, fromparams, hasFreeTicket = false) {
		return post('FlightOrder/createFlightOrder', {
			OpenId: OpenId,
			contactName: contactName,
			contactPhone: contactPhone,
			contactEmail: contactEmail,
			contactQQ: contactQQ,
			remark: remark,
			flightType: flightType,
			cabinRank: cabinRank,
			psgType: psgType,
			passengerList: passengerList,
			flightList: flightList,
			policyList: policyList,
			fromparams: fromparams,
			hasFreeTicket: hasFreeTicket
		});
	},
	cancelFlightOrder(OpenId, OrderNum) {
		return post('FlightOrder/cancelFlightOrder', {
			OpenId: OpenId,
			OrderNum: OrderNum
		});
	},
	getFlightPayParams(OpenId, OrderId, Type, OrderType) {
		return get('Payment/getWeChatFlightPayParams', {
			openid: OpenId,
			id: OrderId,
			type: Type,
			ordertype: OrderType
		});
	},
	getFlightOrderList(OpenId, Count, Page) {
		return get('FlightOrder/getFlightOrderList', {
			openid: OpenId,
			count: Count,
			page: Page
		});
	},
	getFlightOrderDetail(OpenId, OrderId) {
		return post('FlightOrder/getFlightOrderDetail', {
			OpenId: OpenId,
			OrderId: OrderId
		});
	},
	refundFlightOrder(OpenId, OrderNum, Type, Remark, attachmentPath, TicketNumberList = []) {
		return post('FlightOrder/refundFlightOrder', {
			OpenId: OpenId,
			OrderNum: OrderNum,
			Type: Type,
			Remark: Remark,
			attachmentPath: attachmentPath,
			TicketNumberList: TicketNumberList
		});
	},
	appointmentFlight(openid, Productname, name, phone, remark, goDete, backDete) {
		return post('Event/makeBookingMessage', {
			OpenId: openid,
			ProductName: Productname,
			RealName: name,
			Mobile: phone,
			Remark: remark,
			StartDate: goDete,
			EndDate: backDete,
		})
	},
	saveSearchFlightRecord(OpenId, depDate,proName) {
		return post('FlightOrder/SaveSearchFlightRecord', {
			OpenId: OpenId,
			depDate: depDate,
			isFlight: false,
			depCity: proName,
			arrCity: proName,
			depCityPortCode: proName,
			arrCityPortCode: proName
		});
	},
  saveSearchFlightRecord1(OpenId,oldOpenId,type ,depDate,proName,telephone) {
  	return post('FlightOrder/SaveSearchFlightRecord1', {
  		OpenId: OpenId,
      oldOpenId:oldOpenId,
  		depDate: depDate,
  		isFlight: false,
  		depCity: proName,
  		arrCity: proName,
  		depCityPortCode: proName,
  		arrCityPortCode: proName,
      type:type,
      telephone:telephone,
  	});
  },
	getflightorderinfo(Ordernum, Token) {
		return get('manager/flightmanager/getflightorderinfo', {
			token: Token,
			ordernum: Ordernum,
		});
	},
	getFlightcode(Ordernum, Token) {
		return post('manager/flightmanager/getflightcode', {
			token: Token,
			ordernum: Ordernum,
		});
	},
	AutoCreatePnrCode(ordernum) {
		return post('Manager/FlightManager/AutoCreatePnrCode', {
			OrderNum: ordernum,
		});
	},
	AutoPatPrice(ordernum, AutoPatPrice) {
		return post('Manager/FlightManager/AutoPatPrice', {
			OrderNum: ordernum,
			AutoPatPrice: '',
		});
	},
	AutoETDZ(ordernum) {
		return post('Manager/FlightManager/AutoETDZ', {
			OrderNum: ordernum,
		});
	},
	PayFlightOrder(OrderNum){
		return post('Manager/FlightManager/PayFlightOrder', {
			OrderNum: OrderNum
		})
	},
  refundNoTicketFlightOrder(OrderNum,token){
  	return post('Manager/FlightManager/refundNoTicketFlightOrder', {
  		OrderNum: OrderNum,
      token:token,
  	})
  },
}



// WEBPACK FOOTER //
// ./src/request/flightApi.js